import React from 'react';
import t from 'babel-plugin-yate/macro';

import {Text} from '../../components/uiElem';
import {formatRON} from '../../lib/misc';

function OfferGroupItemCetelem(props) {
  const {
    item: {revolving_amount},
  } = props;

  return (
    <React.Fragment>
      <div className="my-3">
        <div className="flex flex-wrap py-2">
          <Text ui="neptune">
            <div className="pr-2">{t`Limita card acordata`}:</div>
          </Text>
          <Text ui="mars">{formatRON(revolving_amount)}</Text>
        </div>
      </div>
    </React.Fragment>
  );
}

export default OfferGroupItemCetelem;
